export default "__VITE_ASSET__DA8amk5H__"